export default __webpack_public_path__ + "static/media/cancel.b7477c68.webp";